import TestRunTopic from './TestRunTopic';

export default class TestProjectRunResults {
    id: string;
    testProjectId: string;
    runTime: string;
    endTime?: string;
    topics: TestRunTopic[];
    error?: string;
    userId?: string;
    documentsCount?: number;
}
